// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file notification.proto (package evenplay.notification.v1, syntax proto3)
/* eslint-disable */

// NotificationService contract for the Messaging & Notification System
// (epic SMG-3044). Backs the SMG-3328 schema.

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file notification.proto.
 */
export const file_notification: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_struct]);

/**
 * @generated from message evenplay.notification.v1.CTA
 */
export type CTA = Message$1<"evenplay.notification.v1.CTA"> & {
  /**
   * 'Keep my turn' / 'Got it' / 'Reconnect'
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * 'primary' | 'secondary' — surface picks the visual class
   *
   * @generated from field: string style = 2;
   */
  style: string;

  /**
   * true iff tapping the CTA writes an ack
   *
   * @generated from field: bool acks = 3;
   */
  acks: boolean;
};

/**
 * Describes the message evenplay.notification.v1.CTA.
 * Use `create(CTASchema)` to create a new message.
 */
export const CTASchema: GenMessage<CTA> = /*@__PURE__*/
  messageDesc(file_notification, 0);

/**
 * @generated from message evenplay.notification.v1.MessageBody
 */
export type MessageBody = Message$1<"evenplay.notification.v1.MessageBody"> & {
  /**
   * required (one line)
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * optional copy
   *
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * optional hint: 'idle-warning'|'top-off'|'celebrate'|...
   *
   * @generated from field: string icon = 3;
   */
  icon: string;

  /**
   * @generated from field: optional evenplay.notification.v1.CTA cta = 4;
   */
  cta?: CTA;

  /**
   * SMG-3144/3150 animation payloads; surfaces ignore unknown keys
   *
   * @generated from field: google.protobuf.Struct rich_payload = 5;
   */
  richPayload?: JsonObject;
};

/**
 * Describes the message evenplay.notification.v1.MessageBody.
 * Use `create(MessageBodySchema)` to create a new message.
 */
export const MessageBodySchema: GenMessage<MessageBody> = /*@__PURE__*/
  messageDesc(file_notification, 1);

/**
 * @generated from message evenplay.notification.v1.Target
 */
export type Target = Message$1<"evenplay.notification.v1.Target"> & {
  /**
   * @generated from field: evenplay.notification.v1.TargetKind kind = 1;
   */
  kind: TargetKind;

  /**
   * empty for broadcast; user_id/station_id/venue_id otherwise
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * reserved for future segmentation; v1 ignores (send-time only)
   *
   * @generated from field: google.protobuf.Struct segment_filter = 3;
   */
  segmentFilter?: JsonObject;
};

/**
 * Describes the message evenplay.notification.v1.Target.
 * Use `create(TargetSchema)` to create a new message.
 */
export const TargetSchema: GenMessage<Target> = /*@__PURE__*/
  messageDesc(file_notification, 2);

/**
 * @generated from message evenplay.notification.v1.Message
 */
export type Message = Message$1<"evenplay.notification.v1.Message"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * Display label only — client-supplied, unverified.
   *
   * @generated from field: optional string created_by = 3;
   */
  createdBy?: string;

  /**
   * @generated from field: evenplay.notification.v1.Target target = 4;
   */
  target?: Target;

  /**
   * denormalized at send time
   *
   * @generated from field: optional int64 venue_id = 5;
   */
  venueId?: bigint;

  /**
   * @generated from field: evenplay.notification.v1.MessageType message_type = 6;
   */
  messageType: MessageType;

  /**
   * @generated from field: evenplay.notification.v1.Severity severity = 7;
   */
  severity: Severity;

  /**
   * @generated from field: bool requires_ack = 8;
   */
  requiresAck: boolean;

  /**
   * @generated from field: evenplay.notification.v1.MessageBody body = 9;
   */
  body?: MessageBody;

  /**
   * @generated from field: optional google.protobuf.Timestamp expires_at = 10;
   */
  expiresAt?: Timestamp;

  /**
   * station_id when session-scoped
   *
   * @generated from field: optional int64 session_id = 11;
   */
  sessionId?: bigint;

  /**
   * @generated from field: optional string correlation_id = 12;
   */
  correlationId?: string;

  /**
   * lifecycle projection (audit lives in message_ack / message_take_down)
   *
   * @generated from field: optional google.protobuf.Timestamp delivered_at = 13;
   */
  deliveredAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp acked_at = 14;
   */
  ackedAt?: Timestamp;

  /**
   * Client-supplied; verified only on the player self-ack path.
   *
   * @generated from field: optional string acked_by = 15;
   */
  ackedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp taken_down_at = 16;
   */
  takenDownAt?: Timestamp;

  /**
   * Carries whichever form the writer produced (see TakeDownRequest): the
   * verified 'service:<name>' principal for a SERVICE caller, an unverified
   * client-supplied display label for an OPERATOR one.
   *
   * @generated from field: optional string taken_down_by = 17;
   */
  takenDownBy?: string;

  /**
   * @generated from field: optional string taken_down_reason = 18;
   */
  takenDownReason?: string;

  /**
   * causal-ordering watermark
   *
   * @generated from field: int64 db_version = 19;
   */
  dbVersion: bigint;

  /**
   * Verified sender, derived server-side from the authenticated JWT
   * ("operator:<user_id>" / "service:<name>"); never accepted from the wire.
   * Populated only on operator-facing responses (GetMessage, QueryMessages,
   * TakeDown, operator Ack, and Send when the stored attribution is the
   * caller's own). Always cleared on recipient surfaces — StreamMessages
   * frames and player/forwarded Ack — so empty means either
   * redacted-for-this-caller or a row written before the attribution
   * migration.
   *
   * @generated from field: string created_by_principal = 20;
   */
  createdByPrincipal: string;
};

/**
 * Describes the message evenplay.notification.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_notification, 3);

/**
 * @generated from message evenplay.notification.v1.Heartbeat
 */
export type Heartbeat = Message$1<"evenplay.notification.v1.Heartbeat"> & {
  /**
   * @generated from field: int64 sequence = 1;
   */
  sequence: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp sent_at = 2;
   */
  sentAt?: Timestamp;
};

/**
 * Describes the message evenplay.notification.v1.Heartbeat.
 * Use `create(HeartbeatSchema)` to create a new message.
 */
export const HeartbeatSchema: GenMessage<Heartbeat> = /*@__PURE__*/
  messageDesc(file_notification, 4);

/**
 * @generated from message evenplay.notification.v1.MessageUpdate
 */
export type MessageUpdate = Message$1<"evenplay.notification.v1.MessageUpdate"> & {
  /**
   * broker sequence (subscriber-populated)
   *
   * @generated from field: int64 sequence = 1;
   */
  sequence: bigint;

  /**
   * @generated from field: evenplay.notification.v1.MessageReason reason = 2;
   */
  reason: MessageReason;

  /**
   * @generated from field: google.protobuf.Timestamp sent_at = 3;
   */
  sentAt?: Timestamp;

  /**
   * causal watermark for dedup
   *
   * @generated from field: int64 db_version = 4;
   */
  dbVersion: bigint;

  /**
   * tiebreaker within one db_version
   *
   * @generated from field: int64 sub_sequence = 5;
   */
  subSequence: bigint;

  /**
   * full snapshot (absent on heartbeat frames)
   *
   * @generated from field: optional evenplay.notification.v1.Message message = 6;
   */
  message?: Message;

  /**
   * set iff this is a keepalive
   *
   * @generated from field: optional evenplay.notification.v1.Heartbeat heartbeat = 7;
   */
  heartbeat?: Heartbeat;
};

/**
 * Describes the message evenplay.notification.v1.MessageUpdate.
 * Use `create(MessageUpdateSchema)` to create a new message.
 */
export const MessageUpdateSchema: GenMessage<MessageUpdate> = /*@__PURE__*/
  messageDesc(file_notification, 5);

/**
 * @generated from message evenplay.notification.v1.SendRequest
 */
export type SendRequest = Message$1<"evenplay.notification.v1.SendRequest"> & {
  /**
   * client-supplied UUID — idempotency key
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: evenplay.notification.v1.Target target = 2;
   */
  target?: Target;

  /**
   * @generated from field: evenplay.notification.v1.MessageType message_type = 3;
   */
  messageType: MessageType;

  /**
   * @generated from field: evenplay.notification.v1.Severity severity = 4;
   */
  severity: Severity;

  /**
   * @generated from field: evenplay.notification.v1.MessageBody body = 5;
   */
  body?: MessageBody;

  /**
   * TOAST auto-dismiss
   *
   * @generated from field: optional int32 auto_dismiss_ms = 6;
   */
  autoDismissMs?: number;

  /**
   * station_id for session-scoped messages
   *
   * @generated from field: optional int64 session_id = 7;
   */
  sessionId?: bigint;

  /**
   * producer dedupe
   *
   * @generated from field: optional string correlation_id = 8;
   */
  correlationId?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp expires_at = 9;
   */
  expiresAt?: Timestamp;

  /**
   * denormalized; optional
   *
   * @generated from field: optional int64 venue_id = 10;
   */
  venueId?: bigint;

  /**
   * Display label only — client-supplied and unverified. Verified attribution
   * is derived server-side; see Message.created_by_principal.
   *
   * @generated from field: optional string created_by = 11;
   */
  createdBy?: string;
};

/**
 * Describes the message evenplay.notification.v1.SendRequest.
 * Use `create(SendRequestSchema)` to create a new message.
 */
export const SendRequestSchema: GenMessage<SendRequest> = /*@__PURE__*/
  messageDesc(file_notification, 6);

/**
 * @generated from message evenplay.notification.v1.SendResponse
 */
export type SendResponse = Message$1<"evenplay.notification.v1.SendResponse"> & {
  /**
   * On a replay of a message_id whose stored attribution is NOT the caller's own
   * (including rows predating the attribution migration) this carries ONLY
   * message_id — get-or-create must not be a read oracle for guessable ids
   * (already_exists still reveals existence, by design). already_exists stays
   * authoritative; treat every other field as absent.
   *
   * @generated from field: evenplay.notification.v1.Message message = 1;
   */
  message?: Message;

  /**
   * true on an idempotent retry (no re-publish)
   *
   * @generated from field: bool already_exists = 2;
   */
  alreadyExists: boolean;
};

/**
 * Describes the message evenplay.notification.v1.SendResponse.
 * Use `create(SendResponseSchema)` to create a new message.
 */
export const SendResponseSchema: GenMessage<SendResponse> = /*@__PURE__*/
  messageDesc(file_notification, 7);

/**
 * @generated from message evenplay.notification.v1.AckRequest
 */
export type AckRequest = Message$1<"evenplay.notification.v1.AckRequest"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * Recipient identifier. Bound to the caller on the player self-ack path;
   * asserted by operator acks. Service-forwarded acks (bay-session, service
   * JWT) carry the recipient keyed by ack_source — MOBILE: the in-bay end
   * user, KIOSK: the station id — checked against recipient ownership.
   * Not verified attribution; see Message.created_by_principal.
   *
   * @generated from field: string acked_by = 2;
   */
  ackedBy: string;

  /**
   * @generated from field: evenplay.notification.v1.AckSource ack_source = 3;
   */
  ackSource: AckSource;
};

/**
 * Describes the message evenplay.notification.v1.AckRequest.
 * Use `create(AckRequestSchema)` to create a new message.
 */
export const AckRequestSchema: GenMessage<AckRequest> = /*@__PURE__*/
  messageDesc(file_notification, 8);

/**
 * @generated from message evenplay.notification.v1.AckResponse
 */
export type AckResponse = Message$1<"evenplay.notification.v1.AckResponse"> & {
  /**
   * @generated from field: evenplay.notification.v1.Message message = 1;
   */
  message?: Message;

  /**
   * true if this (message_id, acked_by) was already acked
   *
   * @generated from field: bool already_acked = 2;
   */
  alreadyAcked: boolean;
};

/**
 * Describes the message evenplay.notification.v1.AckResponse.
 * Use `create(AckResponseSchema)` to create a new message.
 */
export const AckResponseSchema: GenMessage<AckResponse> = /*@__PURE__*/
  messageDesc(file_notification, 9);

/**
 * @generated from message evenplay.notification.v1.TakeDownRequest
 */
export type TakeDownRequest = Message$1<"evenplay.notification.v1.TakeDownRequest"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * Attribution for the audit row. Server-derived for a SERVICE caller: the
   * value sent is ignored and replaced with the verified
   * 'service:<name>' principal, matching Message.created_by_principal.
   * For an OPERATOR caller it is a display label, persisted verbatim and
   * not verified — requireOperator bounds who may write it.
   *
   * @generated from field: string taken_down_by = 2;
   */
  takenDownBy: string;

  /**
   * free-form audit reason (message_take_down.reason_code)
   *
   * @generated from field: string reason_code = 3;
   */
  reasonCode: string;

  /**
   * @generated from field: optional string notes = 4;
   */
  notes?: string;
};

/**
 * Describes the message evenplay.notification.v1.TakeDownRequest.
 * Use `create(TakeDownRequestSchema)` to create a new message.
 */
export const TakeDownRequestSchema: GenMessage<TakeDownRequest> = /*@__PURE__*/
  messageDesc(file_notification, 10);

/**
 * @generated from message evenplay.notification.v1.TakeDownResponse
 */
export type TakeDownResponse = Message$1<"evenplay.notification.v1.TakeDownResponse"> & {
  /**
   * @generated from field: evenplay.notification.v1.Message message = 1;
   */
  message?: Message;

  /**
   * @generated from field: bool already_taken_down = 2;
   */
  alreadyTakenDown: boolean;

  /**
   * set when already_taken_down
   *
   * @generated from field: optional google.protobuf.Timestamp original_taken_down_at = 3;
   */
  originalTakenDownAt?: Timestamp;
};

/**
 * Describes the message evenplay.notification.v1.TakeDownResponse.
 * Use `create(TakeDownResponseSchema)` to create a new message.
 */
export const TakeDownResponseSchema: GenMessage<TakeDownResponse> = /*@__PURE__*/
  messageDesc(file_notification, 11);

/**
 * @generated from message evenplay.notification.v1.StreamMessagesRequest
 */
export type StreamMessagesRequest = Message$1<"evenplay.notification.v1.StreamMessagesRequest"> & {
  /**
   * PLAYER | STATION | VENUE (authorized via JWT)
   *
   * @generated from field: evenplay.notification.v1.TargetKind recipient_kind = 1;
   */
  recipientKind: TargetKind;

  /**
   * @generated from field: string recipient_id = 2;
   */
  recipientId: string;

  /**
   * resume cursor (0 -> server sends a snapshot first)
   *
   * @generated from field: int64 since_sequence = 3;
   */
  sinceSequence: bigint;

  /**
   * reserved (later milestone): causal-watermark resume; v1 ignores — use since_sequence
   *
   * @generated from field: int64 since_db_version = 4;
   */
  sinceDbVersion: bigint;
};

/**
 * Describes the message evenplay.notification.v1.StreamMessagesRequest.
 * Use `create(StreamMessagesRequestSchema)` to create a new message.
 */
export const StreamMessagesRequestSchema: GenMessage<StreamMessagesRequest> = /*@__PURE__*/
  messageDesc(file_notification, 12);

/**
 * @generated from message evenplay.notification.v1.QueryMessagesRequest
 */
export type QueryMessagesRequest = Message$1<"evenplay.notification.v1.QueryMessagesRequest"> & {
  /**
   * @generated from field: optional evenplay.notification.v1.TargetKind target_kind = 1;
   */
  targetKind?: TargetKind;

  /**
   * @generated from field: optional string target_id = 2;
   */
  targetId?: string;

  /**
   * @generated from field: optional evenplay.notification.v1.MessageType message_type = 3;
   */
  messageType?: MessageType;

  /**
   * @generated from field: optional evenplay.notification.v1.Severity severity = 4;
   */
  severity?: Severity;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_after = 5;
   */
  createdAfter?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp created_before = 6;
   */
  createdBefore?: Timestamp;

  /**
   * 'active'|'acked'|'taken_down'|'expired' (v1: string; enum later if needed)
   *
   * @generated from field: optional string status = 7;
   */
  status?: string;

  /**
   * Opaque keyset cursor; empty for the first page. IMPORTANT: when following a
   * next_page_token, repeat every filter field exactly as sent on the first page
   * of the sequence — the token pins a fingerprint of them, and a changed filter
   * set is rejected InvalidArgument. To change filters, restart from the first page.
   *
   * @generated from field: string page_token = 8;
   */
  pageToken: string;

  /**
   * @generated from field: int32 limit = 9;
   */
  limit: number;
};

/**
 * Describes the message evenplay.notification.v1.QueryMessagesRequest.
 * Use `create(QueryMessagesRequestSchema)` to create a new message.
 */
export const QueryMessagesRequestSchema: GenMessage<QueryMessagesRequest> = /*@__PURE__*/
  messageDesc(file_notification, 13);

/**
 * @generated from message evenplay.notification.v1.QueryMessagesResponse
 */
export type QueryMessagesResponse = Message$1<"evenplay.notification.v1.QueryMessagesResponse"> & {
  /**
   * @generated from field: repeated evenplay.notification.v1.Message messages = 1;
   */
  messages: Message[];

  /**
   * opaque cursor for the next page; empty = end
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message evenplay.notification.v1.QueryMessagesResponse.
 * Use `create(QueryMessagesResponseSchema)` to create a new message.
 */
export const QueryMessagesResponseSchema: GenMessage<QueryMessagesResponse> = /*@__PURE__*/
  messageDesc(file_notification, 14);

/**
 * @generated from message evenplay.notification.v1.GetMessageRequest
 */
export type GetMessageRequest = Message$1<"evenplay.notification.v1.GetMessageRequest"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;
};

/**
 * Describes the message evenplay.notification.v1.GetMessageRequest.
 * Use `create(GetMessageRequestSchema)` to create a new message.
 */
export const GetMessageRequestSchema: GenMessage<GetMessageRequest> = /*@__PURE__*/
  messageDesc(file_notification, 15);

/**
 * A single ack audit row (message_ack). Append-only; one per (message_id,
 * acked_by). Surfaced on GetMessageResponse / ListMessageAcks for the delivery
 * dashboard. The internal BIGSERIAL ack_id is intentionally NOT exposed on the
 * wire — pagination carries it inside the opaque page_token, so no RPC accepts a
 * raw sequence id as a lookup key.
 *
 * @generated from message evenplay.notification.v1.MessageAck
 */
export type MessageAck = Message$1<"evenplay.notification.v1.MessageAck"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: google.protobuf.Timestamp acked_at = 2;
   */
  ackedAt?: Timestamp;

  /**
   * Recipient identifier (user id / sim id). Client-supplied; bound to the
   * caller only on the player self-ack path — operator and forwarded acks
   * assert it. Not verified attribution; see Message.created_by_principal.
   *
   * @generated from field: string acked_by = 3;
   */
  ackedBy: string;

  /**
   * mobile|kiosk|crm|api
   *
   * @generated from field: string ack_source = 4;
   */
  ackSource: string;
};

/**
 * Describes the message evenplay.notification.v1.MessageAck.
 * Use `create(MessageAckSchema)` to create a new message.
 */
export const MessageAckSchema: GenMessage<MessageAck> = /*@__PURE__*/
  messageDesc(file_notification, 16);

/**
 * A single take-down audit row (message_take_down). Append-only; an operator may
 * record more than one (only the first flips the projection). The internal
 * BIGSERIAL take_down_id is intentionally NOT exposed (see MessageAck).
 *
 * @generated from message evenplay.notification.v1.MessageTakeDown
 */
export type MessageTakeDown = Message$1<"evenplay.notification.v1.MessageTakeDown"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: google.protobuf.Timestamp taken_down_at = 2;
   */
  takenDownAt?: Timestamp;

  /**
   * Carries whichever form the writer produced (see TakeDownRequest): the
   * verified 'service:<name>' principal for a SERVICE caller, an unverified
   * client-supplied display label for an OPERATOR one.
   *
   * @generated from field: string taken_down_by = 3;
   */
  takenDownBy: string;

  /**
   * @generated from field: string reason_code = 4;
   */
  reasonCode: string;

  /**
   * @generated from field: optional string notes = 5;
   */
  notes?: string;
};

/**
 * Describes the message evenplay.notification.v1.MessageTakeDown.
 * Use `create(MessageTakeDownSchema)` to create a new message.
 */
export const MessageTakeDownSchema: GenMessage<MessageTakeDown> = /*@__PURE__*/
  messageDesc(file_notification, 17);

/**
 * @generated from message evenplay.notification.v1.GetMessageResponse
 */
export type GetMessageResponse = Message$1<"evenplay.notification.v1.GetMessageResponse"> & {
  /**
   * @generated from field: evenplay.notification.v1.Message message = 1;
   */
  message?: Message;

  /**
   * FIRST PAGE of the ack audit trail, oldest first
   *
   * @generated from field: repeated evenplay.notification.v1.MessageAck acks = 2;
   */
  acks: MessageAck[];

  /**
   * FIRST PAGE of the take-down audit trail, oldest first
   *
   * @generated from field: repeated evenplay.notification.v1.MessageTakeDown take_downs = 3;
   */
  takeDowns: MessageTakeDown[];

  /**
   * Continuation cursors for the trails above; empty = the full trail fit in the
   * first page. When set, fetch the rest via ListMessageAcks / ListMessageTakeDowns
   * (a heavily-acked broadcast can have more audit rows than one response should carry).
   *
   * @generated from field: string acks_next_page_token = 4;
   */
  acksNextPageToken: string;

  /**
   * @generated from field: string take_downs_next_page_token = 5;
   */
  takeDownsNextPageToken: string;
};

/**
 * Describes the message evenplay.notification.v1.GetMessageResponse.
 * Use `create(GetMessageResponseSchema)` to create a new message.
 */
export const GetMessageResponseSchema: GenMessage<GetMessageResponse> = /*@__PURE__*/
  messageDesc(file_notification, 18);

/**
 * @generated from message evenplay.notification.v1.ListMessageAcksRequest
 */
export type ListMessageAcksRequest = Message$1<"evenplay.notification.v1.ListMessageAcksRequest"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * opaque cursor; empty for the first page
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * clamped server-side (default 50, max 200)
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message evenplay.notification.v1.ListMessageAcksRequest.
 * Use `create(ListMessageAcksRequestSchema)` to create a new message.
 */
export const ListMessageAcksRequestSchema: GenMessage<ListMessageAcksRequest> = /*@__PURE__*/
  messageDesc(file_notification, 19);

/**
 * @generated from message evenplay.notification.v1.ListMessageAcksResponse
 */
export type ListMessageAcksResponse = Message$1<"evenplay.notification.v1.ListMessageAcksResponse"> & {
  /**
   * oldest first
   *
   * @generated from field: repeated evenplay.notification.v1.MessageAck acks = 1;
   */
  acks: MessageAck[];

  /**
   * empty = end
   *
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message evenplay.notification.v1.ListMessageAcksResponse.
 * Use `create(ListMessageAcksResponseSchema)` to create a new message.
 */
export const ListMessageAcksResponseSchema: GenMessage<ListMessageAcksResponse> = /*@__PURE__*/
  messageDesc(file_notification, 20);

/**
 * @generated from message evenplay.notification.v1.ListMessageTakeDownsRequest
 */
export type ListMessageTakeDownsRequest = Message$1<"evenplay.notification.v1.ListMessageTakeDownsRequest"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message evenplay.notification.v1.ListMessageTakeDownsRequest.
 * Use `create(ListMessageTakeDownsRequestSchema)` to create a new message.
 */
export const ListMessageTakeDownsRequestSchema: GenMessage<ListMessageTakeDownsRequest> = /*@__PURE__*/
  messageDesc(file_notification, 21);

/**
 * @generated from message evenplay.notification.v1.ListMessageTakeDownsResponse
 */
export type ListMessageTakeDownsResponse = Message$1<"evenplay.notification.v1.ListMessageTakeDownsResponse"> & {
  /**
   * oldest first
   *
   * @generated from field: repeated evenplay.notification.v1.MessageTakeDown take_downs = 1;
   */
  takeDowns: MessageTakeDown[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message evenplay.notification.v1.ListMessageTakeDownsResponse.
 * Use `create(ListMessageTakeDownsResponseSchema)` to create a new message.
 */
export const ListMessageTakeDownsResponseSchema: GenMessage<ListMessageTakeDownsResponse> = /*@__PURE__*/
  messageDesc(file_notification, 22);

/**
 * Dismissal-behavior taxonomy (design "Type taxonomy"). -> messages.message_type
 *
 * @generated from enum evenplay.notification.v1.MessageType
 */
export enum MessageType {
  /**
   * @generated from enum value: MESSAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_TYPE_TOAST = 1;
   */
  TOAST = 1,

  /**
   * @generated from enum value: MESSAGE_TYPE_PERSISTENT_SIM = 2;
   */
  PERSISTENT_SIM = 2,

  /**
   * @generated from enum value: MESSAGE_TYPE_PERSISTENT_PLAYER = 3;
   */
  PERSISTENT_PLAYER = 3,

  /**
   * @generated from enum value: MESSAGE_TYPE_CONFIRMATION = 4;
   */
  CONFIRMATION = 4,
}

/**
 * Describes the enum evenplay.notification.v1.MessageType.
 */
export const MessageTypeSchema: GenEnum<MessageType> = /*@__PURE__*/
  enumDesc(file_notification, 0);

/**
 * -> messages.severity
 *
 * @generated from enum evenplay.notification.v1.Severity
 */
export enum Severity {
  /**
   * @generated from enum value: SEVERITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEVERITY_INFO = 1;
   */
  INFO = 1,

  /**
   * @generated from enum value: SEVERITY_WARN = 2;
   */
  WARN = 2,

  /**
   * @generated from enum value: SEVERITY_CELEBRATE = 3;
   */
  CELEBRATE = 3,

  /**
   * @generated from enum value: SEVERITY_ERROR = 4;
   */
  ERROR = 4,
}

/**
 * Describes the enum evenplay.notification.v1.Severity.
 */
export const SeveritySchema: GenEnum<Severity> = /*@__PURE__*/
  enumDesc(file_notification, 1);

/**
 * -> messages.target_kind
 *
 * @generated from enum evenplay.notification.v1.TargetKind
 */
export enum TargetKind {
  /**
   * @generated from enum value: TARGET_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TARGET_KIND_BROADCAST = 1;
   */
  BROADCAST = 1,

  /**
   * @generated from enum value: TARGET_KIND_VENUE = 2;
   */
  VENUE = 2,

  /**
   * @generated from enum value: TARGET_KIND_STATION = 3;
   */
  STATION = 3,

  /**
   * @generated from enum value: TARGET_KIND_PLAYER = 4;
   */
  PLAYER = 4,
}

/**
 * Describes the enum evenplay.notification.v1.TargetKind.
 */
export const TargetKindSchema: GenEnum<TargetKind> = /*@__PURE__*/
  enumDesc(file_notification, 2);

/**
 * -> message_ack.ack_source
 *
 * @generated from enum evenplay.notification.v1.AckSource
 */
export enum AckSource {
  /**
   * @generated from enum value: ACK_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACK_SOURCE_MOBILE = 1;
   */
  MOBILE = 1,

  /**
   * @generated from enum value: ACK_SOURCE_KIOSK = 2;
   */
  KIOSK = 2,

  /**
   * @generated from enum value: ACK_SOURCE_CRM = 3;
   */
  CRM = 3,

  /**
   * @generated from enum value: ACK_SOURCE_API = 4;
   */
  API = 4,
}

/**
 * Describes the enum evenplay.notification.v1.AckSource.
 */
export const AckSourceSchema: GenEnum<AckSource> = /*@__PURE__*/
  enumDesc(file_notification, 3);

/**
 * What triggered a MessageUpdate (the analog of bay-session's
 * SessionStateReason). Wire/stream concept only — no DB column.
 *
 * @generated from enum evenplay.notification.v1.MessageReason
 */
export enum MessageReason {
  /**
   * @generated from enum value: MESSAGE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_REASON_CREATED = 1;
   */
  CREATED = 1,

  /**
   * @generated from enum value: MESSAGE_REASON_ACKED = 2;
   */
  ACKED = 2,

  /**
   * @generated from enum value: MESSAGE_REASON_TAKEN_DOWN = 3;
   */
  TAKEN_DOWN = 3,

  /**
   * @generated from enum value: MESSAGE_REASON_EXPIRED = 4;
   */
  EXPIRED = 4,

  /**
   * @generated from enum value: MESSAGE_REASON_RESYNC = 5;
   */
  RESYNC = 5,
}

/**
 * Describes the enum evenplay.notification.v1.MessageReason.
 */
export const MessageReasonSchema: GenEnum<MessageReason> = /*@__PURE__*/
  enumDesc(file_notification, 4);

/**
 * @generated from service evenplay.notification.v1.NotificationService
 */
export const NotificationService: GenService<{
  /**
   * CRM/producer compose+send. Idempotent on message_id.
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.Send
   */
  send: {
    methodKind: "unary";
    input: typeof SendRequestSchema;
    output: typeof SendResponseSchema;
  },
  /**
   * Recipient ack (own JWT) or operator/service ack. Idempotent on (message_id, acked_by).
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.Ack
   */
  ack: {
    methodKind: "unary";
    input: typeof AckRequestSchema;
    output: typeof AckResponseSchema;
  },
  /**
   * Operator/system take-down. Appends an audit row; first call flips the projection.
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.TakeDown
   */
  takeDown: {
    methodKind: "unary";
    input: typeof TakeDownRequestSchema;
    output: typeof TakeDownResponseSchema;
  },
  /**
   * Per-recipient live stream (own JWT; cross-recipient subscriptions rejected).
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.StreamMessages
   */
  streamMessages: {
    methodKind: "server_streaming";
    input: typeof StreamMessagesRequestSchema;
    output: typeof MessageUpdateSchema;
  },
  /**
   * CRM dashboard query with keyset (created_at, message_id) cursor pagination.
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.QueryMessages
   */
  queryMessages: {
    methodKind: "unary";
    input: typeof QueryMessagesRequestSchema;
    output: typeof QueryMessagesResponseSchema;
  },
  /**
   * Fetch a single message by id plus the first page of its ack / take-down audit trail.
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.GetMessage
   */
  getMessage: {
    methodKind: "unary";
    input: typeof GetMessageRequestSchema;
    output: typeof GetMessageResponseSchema;
  },
  /**
   * Paginated ack audit trail for one message (keyset cursor on the ack's serial id).
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.ListMessageAcks
   */
  listMessageAcks: {
    methodKind: "unary";
    input: typeof ListMessageAcksRequestSchema;
    output: typeof ListMessageAcksResponseSchema;
  },
  /**
   * Paginated take-down audit trail for one message (keyset cursor on the take-down's serial id).
   *
   * @generated from rpc evenplay.notification.v1.NotificationService.ListMessageTakeDowns
   */
  listMessageTakeDowns: {
    methodKind: "unary";
    input: typeof ListMessageTakeDownsRequestSchema;
    output: typeof ListMessageTakeDownsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_notification, 0);

